/// <amd-module name="Wit/BoardsHub/Common/SwimlaneUtils" />

import { CardRule, FilterClause } from "./Client/Contracts/Settings";
import { CardRuleTypes } from "./StylesUtils";

export interface ISwimlaneRules {
    rowId: string;
    filterClauses: FilterClause[];
}

export function getSwimlaneRulesFromRules(rules: CardRule[]): ISwimlaneRules[] {
    return rules
        .filter(rule => rule.type === CardRuleTypes.SwimlaneRule)
        .map(rule => {
            return {
                rowId: (rule.style as any)["rowId"],
                filterClauses: rule.criteria?.clauses ?? []
            };
        });
}

export function areSwimlaneRulesNonEmpty(rule: ISwimlaneRules | undefined): boolean {
    return !!rule?.filterClauses?.length;
}
